export default __webpack_public_path__ + "static/media/equest.efb46115.svg";